import { Injectable,NgZone } from '@angular/core';
import { Subject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class InactivityService {
  public userInactive: Subject<any> = new Subject();
  public userActivity;
  timeout: number;
  constructor(private ngZone: NgZone) {

  
   }


  setTimeoutInactivity(time:number) {
   
   this.userActivity = setTimeout(() => this.userInactive.next(undefined), time);
  }

  
  setTimeoutInactivityNew(timeout: number) {
    this.timeout = timeout;
    this.ngZone.runOutsideAngular(() => {
      this.resetTimer();
      window.addEventListener('mousemove', () => this.resetTimer());
      window.addEventListener('keydown', () => this.resetTimer());
      window.addEventListener('click', () => this.resetTimer());
      window.addEventListener('scroll', () => this.resetTimer());
    });
  }

  private resetTimer() {
    clearTimeout(this.userActivity);
    this.userActivity = setTimeout(() => {
      this.userInactive.next(true);
    }, this.timeout);
  }


}

